const STAX_SCRIPT_URL =
    "https://staxjs.staxpayments.com/staxjs-captcha.js";

export const loadStax = () => {

    return new Promise((resolve, reject) => {

        if (window.StaxJs) {
            resolve(window.StaxJs);
            return;
        }

        const existingScript =
            document.querySelector(
                `script[src="${STAX_SCRIPT_URL}"]`
            );

        if (existingScript) {

            existingScript.addEventListener(
                "load",
                () => resolve(window.StaxJs)
            );

            existingScript.addEventListener(
                "error",
                reject
            );

            return;
        }

        const script =
            document.createElement("script");

        script.src = STAX_SCRIPT_URL;
        script.async = true;

        script.onload = () => {

            if (window.StaxJs) {
                resolve(window.StaxJs);
            } else {
                reject(
                    new Error(
                        "StaxJs is not available after script loading."
                    )
                );
            }
        };

        script.onerror = () => {

            reject(
                new Error(
                    "Failed to load Stax.js"
                )
            );
        };

        document.body.appendChild(script);
    });
};